import { TbMessageDots } from 'react-icons/tb';
import { ActivityLog } from 'wisestep-api';
import { WsSelectObj, WsColors, WsFillCheck, WsSquareCheckBig } from 'wisestep-base';

import ClosedJobIcon from '../../../../../conversationWidget/components/ClosedJobIcon';
import JobAcceptedIcon from '../../../../../conversationWidget/components/JobAcceptedIcon';
import JobOpenIcon from '../../../../../conversationWidget/components/JobOpenIcon';
import MapConversationIcon from '../../../../../conversationWidget/components/MapConversationIcon';
import ReopenedJobIcon from '../../../../../conversationWidget/components/ReopenJobIcon';
export const activityOptions: WsSelectObj[] = [
  {
    label: 'Select',
    value: '',
  },
  {
    label: 'Mapping',
    value: 'INTERACTION',
  },

  {
    label: 'Submission_created',
    value: 'SUBMISSION_CREATED',
  },
  {
    label: 'Submission_updated',
    value: 'SUBMISSION_UPDATED',
  },
  {
    label: 'PipeLine',
    value: 'PIPELINE',
  },
  {
    label: 'Email',
    value: 'EMAIL',
  },
  {
    label: 'SMS',
    value: 'SMS',
  },
  {
    label: 'Phone',
    value: 'CALL',
  },
  {
    label: 'Submission_action',
    value: 'SUBMISSION_ACTION',
  },
];

export const jobActivityOptions: WsSelectObj[] = [
  {
    label: 'Select',
    value: '',
  },
  { label: 'Created', value: 'CREATED' },
  { label: 'Updated', value: 'UPDATED' },
  { label: 'Close Job', value: 'CLOSE_JOB' },
  { label: 'Assigned', value: 'ASSIGNED' },
  { label: 'Unassigned', value: 'UNASSIGNED' },
  { label: 'Accepted', value: 'ACCEPTED' },
];

export interface ActivityLogItemProps {
  index: number;
  candidate: string;
  activity: ActivityLog;
  isLast?: boolean;
  onclick?: (activity: ActivityLog) => void;
  openPreview?: (action: boolean) => void;
  logId?: (id: string) => void;
  auditId?: string;
  rowId?: any;
  selectedButtonId: string;
  onClickView: (id: string) => void;
  jobsActivity?: boolean;
}

export const separatorIcons = {
  INTERACTION: <MapConversationIcon />,
  SUBMISSION_CREATED: <WsFillCheck />,
  SUBMISSION_UPDATED: <WsFillCheck />,
  SUBMISSION_ACTION: <WsFillCheck />,
  PIPELINE: <WsSquareCheckBig />,
  SMS: <TbMessageDots />,
  EMAIL: <TbMessageDots />,
  CREATED: <JobOpenIcon />,
  UPDATED: <JobAcceptedIcon />,
  CLOSE_JOB: <ClosedJobIcon />,
  ASSIGNED: <ReopenedJobIcon />,
  UNASSIGNED: <ReopenedJobIcon />,
  ACCEPTED: <ReopenedJobIcon />,
  REOPEN_JOB: <ReopenedJobIcon />,
};

export const iconBg = {
  INTERACTION: WsColors.TheBlues500,
  SUBMISSION_CREATED: WsColors.BackGroundGreen,
  SUBMISSION_UPDATED: WsColors.BackGroundGreen,
  SUBMISSION_ACTION: WsColors.BackGroundGreen,
  PIPELINE: WsColors.BackGroundGreen,
  Communication: WsColors.BackGroundGreen,
  SMS: WsColors.BackGroundGreen,
  EMAIL: WsColors.BackGroundGreen,
  CREATED: WsColors.TheBlues500,
  UPDATED: WsColors.TheBlues500,
  CLOSE_JOB: WsColors.TheBlues500,
  ASSIGNED: WsColors.TheBlues500,
  UNASSIGNED: WsColors.TheBlues500,
  ACCEPTED: WsColors.TheBlues500,
  REOPEN_JOB: WsColors.TheBlues500,
};

export const action = {
  INTERACTION: 'Mapped',
  SUBMISSION_CREATED: 'Submitted',
  SUBMISSION_ACTION: 'Submitted',
  SUBMISSION_UPDATED: 'Update the submission',
  PIPELINE: 'made an Update',
  SMS: 'Sent SMS',
  EMAIL: 'Sent Email',
  UPLOADED: 'uploaded the candidate',
  CANDIDATE_UPDATED: 'has updated profile details',
  UPDATE_SUBMISSION: 'has updated submission details',
};

export const viewButton = {
  INTERACTION: 'Interaction',
  SUBMISSION_CREATED: 'Submission',
  SUBMISSION_UPDATED: 'submission',
  SUBMISSION_ACTION: 'Submission',
  PIPELINE: 'Stage Status',
  SMS: 'SMS',
  EMAIL: 'Email',
};
